import React from 'react';
import { twMerge } from 'utilities/src/twMerge';
import Link from 'next/link';
import useChipTheme from './themes';
import { type ChipThemeProps } from './types/_theme';

export type ChipProps = ChipThemeProps & {
  name: string;
  link?: string;
  customClasses?: string;
  keepLinkStylesWithoutUrl?: boolean;
};

function Chip({ name, link, bg, customClasses, keepLinkStylesWithoutUrl }: ChipProps) {
  const { chipLinkClasses, chipTextClasses, chipLinkColorClasses } = useChipTheme({ bg });
  return link ? (
    <Link className={twMerge(chipLinkClasses, chipLinkColorClasses, customClasses)} href={link}>
      {name}
    </Link>
  ) : (
    <span
      className={twMerge(customClasses, {
        [chipTextClasses]: !keepLinkStylesWithoutUrl,
        [chipLinkColorClasses]: keepLinkStylesWithoutUrl,
        [chipLinkClasses]: keepLinkStylesWithoutUrl,
      })}
    >
      {name}
    </span>
  );
}

export default Chip;
